export enum LimitMode {
    Manual,
    Scan,
}

export enum LimitEnable {
    No,
    Yes,
}

export enum LimitStatus {
    NotLimited,
    Limited,
}

export enum Limited {
    EnableLeft = 1,
    EnableRight = 2,
    EnableDown = 4,
    EnableUp = 8,
}

export interface PTZLimit {
    Mode: LimitMode;
    ManualLimitEnable: LimitEnable;
    ManualLimitStatus: LimitStatus;
    ManualLimited: Limited;
    ScanLimitEnable: LimitEnable;
    ScanLimitStatus: LimitStatus;
    ScanLimited?: Limited;
}
